/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTags } from '../fn/tags/create-tags';
import { CreateTags$Params } from '../fn/tags/create-tags';
import { deleteTag } from '../fn/tags/delete-tag';
import { DeleteTag$Params } from '../fn/tags/delete-tag';
import { EntityIdListResponse } from '../models/entity-id-list-response';
import { getAssociationsByEntity } from '../fn/tags/get-associations-by-entity';
import { GetAssociationsByEntity$Params } from '../fn/tags/get-associations-by-entity';
import { getAssociationsByTag } from '../fn/tags/get-associations-by-tag';
import { GetAssociationsByTag$Params } from '../fn/tags/get-associations-by-tag';
import { getTag } from '../fn/tags/get-tag';
import { GetTag$Params } from '../fn/tags/get-tag';
import { getTags } from '../fn/tags/get-tags';
import { GetTags$Params } from '../fn/tags/get-tags';
import { getTagsBulk } from '../fn/tags/get-tags-bulk';
import { GetTagsBulk$Params } from '../fn/tags/get-tags-bulk';
import { Tag } from '../models/tag';
import { TagListResponse } from '../models/tag-list-response';
import { TagMapResponse } from '../models/tag-map-response';
import { updateTag } from '../fn/tags/update-tag';
import { UpdateTag$Params } from '../fn/tags/update-tag';
import { upsertCatalogEntryIdAssociations } from '../fn/tags/upsert-catalog-entry-id-associations';
import { UpsertCatalogEntryIdAssociations$Params } from '../fn/tags/upsert-catalog-entry-id-associations';
import { upsertTagAssociations } from '../fn/tags/upsert-tag-associations';
import { UpsertTagAssociations$Params } from '../fn/tags/upsert-tag-associations';

@Injectable({ providedIn: 'root' })
export class TagsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTags()` */
  static readonly GetTagsPath = '/tags';

  /**
   * Get Tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags$Response(params: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagListResponse>> {
    return getTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags(params: GetTags$Params, context?: HttpContext): Observable<TagListResponse> {
    return this.getTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagListResponse>): TagListResponse => r.body)
    );
  }

  /** Path part for operation `createTags()` */
  static readonly CreateTagsPath = '/tags';

  /**
   * Create Tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTags$Response(params: CreateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    return createTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTags(params: CreateTags$Params, context?: HttpContext): Observable<Tag> {
    return this.createTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `getTag()` */
  static readonly GetTagPath = '/tags/{id}';

  /**
   * Get Tag by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTag$Response(params: GetTag$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    return getTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tag by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTag(params: GetTag$Params, context?: HttpContext): Observable<Tag> {
    return this.getTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `updateTag()` */
  static readonly UpdateTagPath = '/tags/{id}';

  /**
   * update tag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTag$Response(params: UpdateTag$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    return updateTag(this.http, this.rootUrl, params, context);
  }

  /**
   * update tag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTag(params: UpdateTag$Params, context?: HttpContext): Observable<Tag> {
    return this.updateTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `deleteTag()` */
  static readonly DeleteTagPath = '/tags/{id}';

  /**
   * delete tag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTag$Response(params: DeleteTag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTag(this.http, this.rootUrl, params, context);
  }

  /**
   * delete tag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTag(params: DeleteTag$Params, context?: HttpContext): Observable<void> {
    return this.deleteTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `upsertTagAssociations()` */
  static readonly UpsertTagAssociationsPath = '/associations/{id}';

  /**
   * upsert tag associations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertTagAssociations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertTagAssociations$Response(params: UpsertTagAssociations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upsertTagAssociations(this.http, this.rootUrl, params, context);
  }

  /**
   * upsert tag associations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertTagAssociations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertTagAssociations(params: UpsertTagAssociations$Params, context?: HttpContext): Observable<void> {
    return this.upsertTagAssociations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAssociationsByTag()` */
  static readonly GetAssociationsByTagPath = '/associations/tag/{id}';

  /**
   * get tag associations by tag ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssociationsByTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssociationsByTag$Response(params: GetAssociationsByTag$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityIdListResponse>> {
    return getAssociationsByTag(this.http, this.rootUrl, params, context);
  }

  /**
   * get tag associations by tag ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAssociationsByTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssociationsByTag(params: GetAssociationsByTag$Params, context?: HttpContext): Observable<EntityIdListResponse> {
    return this.getAssociationsByTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<EntityIdListResponse>): EntityIdListResponse => r.body)
    );
  }

  /** Path part for operation `getAssociationsByEntity()` */
  static readonly GetAssociationsByEntityPath = '/associations/entity/{id}';

  /**
   * get tag associations by entity ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssociationsByEntity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssociationsByEntity$Response(params: GetAssociationsByEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<TagListResponse>> {
    return getAssociationsByEntity(this.http, this.rootUrl, params, context);
  }

  /**
   * get tag associations by entity ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAssociationsByEntity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssociationsByEntity(params: GetAssociationsByEntity$Params, context?: HttpContext): Observable<TagListResponse> {
    return this.getAssociationsByEntity$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagListResponse>): TagListResponse => r.body)
    );
  }

  /** Path part for operation `getTagsBulk()` */
  static readonly GetTagsBulkPath = '/associations/entities_bulk';

  /**
   * get tags for multiple entities
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsBulk$Response(params: GetTagsBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<TagMapResponse>> {
    return getTagsBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * get tags for multiple entities
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsBulk(params: GetTagsBulk$Params, context?: HttpContext): Observable<TagMapResponse> {
    return this.getTagsBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagMapResponse>): TagMapResponse => r.body)
    );
  }

  /** Path part for operation `upsertCatalogEntryIdAssociations()` */
  static readonly UpsertCatalogEntryIdAssociationsPath = '/catalogs/{catalogEntryId}/associations';

  /**
   * Associate tags to catalogEntryId.
   *
   * Associate entity IDs to a tag ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertCatalogEntryIdAssociations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCatalogEntryIdAssociations$Response(params: UpsertCatalogEntryIdAssociations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upsertCatalogEntryIdAssociations(this.http, this.rootUrl, params, context);
  }

  /**
   * Associate tags to catalogEntryId.
   *
   * Associate entity IDs to a tag ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertCatalogEntryIdAssociations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCatalogEntryIdAssociations(params: UpsertCatalogEntryIdAssociations$Params, context?: HttpContext): Observable<void> {
    return this.upsertCatalogEntryIdAssociations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
